// extracted by mini-css-extract-plugin
export var wrapper = "b_b";
export var containerWrapper = "b_c";
export var contentWrapper = "b_d";
export var textWrapper = "b_f";
export var text = "b_g";
export var more = "b_h";
export var spacer = "b_j";
export var imageWrapper = "b_k";
export var imageMobile = "b_l";
export var imageTablet = "b_m";
export var imageDesktop = "b_n";
export var dotGroup = "b_p";
export var elementWrapper = "b_q";
export var element = "b_r";